import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function Home() {
  useEffect(() => {
    document.title = 'Stainless & Carbon Steel Environmental Fabrication | Yixing, China'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) metaDesc.setAttribute('content', 'Factory-backed stainless steel and carbon steel environmental fabrication, with project supply coordination and selected specialist equipment partners in Yixing, China.')
  }, [])

  return (
    <div className="home-page">
      <section className="hero" id="top">
        <div className="hero-content">
          <p className="eyebrow">YIXING, CHINA · FACTORY-BACKED ENVIRONMENTAL EQUIPMENT SUPPLY</p>
          <h1>Stainless Steel & Carbon Steel Environmental Fabrication for EPC Projects</h1>
          <p className="hero-subtitle">
            Grace Wang coordinates project-specific stainless steel and carbon steel fabrication through a family-owned manufacturing facility in Yixing, with selected specialist partners supporting additional environmental equipment packages.
          </p>
          <p>
            From drawings and scope clarification to production follow-up, inspection documentation and export communication, customers work through one consistent project contact.
          </p>
          <div className="hero-cta">
            <Link to="/contact" className="btn-primary">Send Your RFQ or Drawings ↗</Link>
            <Link to="/sourcing-capabilities" className="btn-secondary">View Manufacturing Capabilities →</Link>
          </div>
          <ul className="hero-highlights">
            <li>Family-owned stainless steel and carbon steel manufacturing support</li>
            <li>10+ years of environmental industry experience</li>
            <li>Yixing environmental equipment supply network</li>
          </ul>
        </div>
      </section>

      <section className="supply-model" id="equipment">
        <div className="section-inner">
          <h2>Two Clear Supply Routes</h2>
          <p className="section-intro">The manufacturing source is matched to the confirmed equipment scope—and stated clearly before quotation.</p>

          <div className="route-card">
            <h3>Factory-Backed Metal Fabrication</h3>
            <p>Project-specific stainless steel and carbon steel equipment, frames, skids, tanks, housings and fabricated components produced through a family-owned manufacturing facility in Yixing.</p>
            <p>Factory-provided capability information covers drawing-based cutting and forming, carbon steel and stainless steel welding, project-specific surface protection, assembly checks and agreed inspection documentation.</p>
            <p>All manufacturing capabilities, materials, dimensions, welding requirements, inspection documents and production limits are confirmed against the actual project specification before quotation.</p>
            <Link to="/sourcing-capabilities" className="link-arrow">Review the verified scope →</Link>
          </div>
        </div>
      </section>

      <section className="equipment-categories">
        <div className="section-inner">
          <h2>Equipment Categories</h2>
          <div className="category-grid">
            <Link to="/sludge-dewatering-equipment" className="category-card">
              <h3>Sludge Dewatering Equipment</h3>
              <p>Project-specific sludge dewatering equipment coordinated through selected specialist manufacturing partners in Yixing, China.</p>
            </Link>
            <Link to="/wastewater-treatment-equipment" className="category-card">
              <h3>Wastewater Treatment Equipment</h3>
              <p>Defined wastewater pretreatment and treatment equipment packages supplied through selected specialist manufacturing partners.</p>
            </Link>
            <Link to="/odor-control-equipment" className="category-card">
              <h3>Odor Control Equipment</h3>
              <p>Biological odor control and activated carbon equipment with selected specialist manufacturing partners supplying FRP and PP packages.</p>
            </Link>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="section-inner">
          <h2>Start with Your Project Requirements</h2>
          <p>Share the scope before scheduling the technical step.</p>
          <p>For an initial written review, share the application, capacity or airflow, key contaminants, required equipment scope, preferred materials, available drawings, destination and target schedule.</p>
          <Link to="/contact" className="btn-primary">Send Requirements by Email ↗</Link>
        </div>
      </section>
    </div>
  )
}
